__turbopack_context__.v({
  "component_props": "_8V2Ytq_component_props",
  "component_props__code": "_8V2Ytq_component_props__code",
  "component_props__color": "_8V2Ytq_component_props__color",
  "component_props__doc-keyword": "_8V2Ytq_component_props__doc-keyword",
  "component_props__params-list": "_8V2Ytq_component_props__params-list",
  "component_props__params-title": "_8V2Ytq_component_props__params-title",
  "component_props__type": "_8V2Ytq_component_props__type",
  "component_props__type-wrapper": "_8V2Ytq_component_props__type-wrapper",
});
